// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__vth0W","boxTitle":"Qualiphy_boxTitle__5pJbz","box":"Qualiphy_box__2zewy","toggleWrap":"Qualiphy_toggleWrap__1J7eW"};